module.exports = __webpack_public_path__ + "static/media/animated-1-Ca.c7186d5e.gif";